export const pad2 = n => String(n).padStart(2, '0')
export const localDate = d => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
export const localTime = d => `${pad2(d.getHours())}:${pad2(d.getMinutes())}`
export const todayISO = () => localDate(new Date())

export const dayLabel = (iso) => {
  const d = new Date(iso)
  const today = new Date()
  const yesterday = new Date(); yesterday.setDate(today.getDate() - 1)
  if (localDate(d) === localDate(today)) return 'Today'
  if (localDate(d) === localDate(yesterday)) return 'Yesterday'
  return d.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' })
}

export const clockTime = (ts) => {
  const d = new Date(ts)
  return d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
}
